(() => {
  if (window.PoptexCustomizerNavigation) return;
  const returnKey = 'customizer_return';
  const previewKeys = ['preview_theme_id', '_fd', 'pb'];
  const scriptRoot = document.currentScript?.dataset.rootUrl || '/';
  const isCustomizer = url => url.searchParams.get('view') === 'design';
  const sourceUrl = value => {
    if (!value) return null;
    try {
      const url = new URL(value, location.href);
      if (!/^https?:$/.test(url.protocol) || url.origin !== location.origin || url.username || url.password || isCustomizer(url)
        || /(?:^|\/)(?:account|accounts|customer_authentication|authentication|auth|oauth|authorize|callback)(?:\/|$)/i.test(url.pathname)) return null;
      url.searchParams.delete(returnKey);
      return url;
    } catch { return null; }
  };
  const pathOf = url => url.pathname + url.search + url.hash;
  const withPreview = url => {
    const current = new URL(location.href);
    for (const key of previewKeys) if (!url.searchParams.has(key) && current.searchParams.has(key)) url.searchParams.set(key, current.searchParams.get(key));
    return url;
  };
  const decorate = anchor => {
    if (!anchor?.hasAttribute('href')) return;
    const source = sourceUrl(location.href);
    if (!source) return;
    try {
      const url = new URL(anchor.getAttribute('href'), location.href);
      if (url.origin !== location.origin || !isCustomizer(url)) return;
      url.searchParams.set(returnKey, pathOf(source));
      const href = pathOf(withPreview(url));
      if (anchor.getAttribute('href') !== href) anchor.setAttribute('href', href);
    } catch { /* Leave malformed or non-HTTP links alone. */ }
  };
  const initialize = (scope = document) => {
    scope.querySelectorAll('a[href]').forEach(decorate);
    const current = new URL(location.href);
    scope.querySelectorAll('[data-customizer-back]').forEach(link => {
      const destination = withPreview(sourceUrl(current.searchParams.get(returnKey)) || sourceUrl(document.referrer) || new URL(link.getAttribute('href') || scriptRoot, location.origin));
      link.href = pathOf(destination);
      // Pin this entry's source through refresh and the existing login round trip.
      if (isCustomizer(current) && current.searchParams.get(returnKey) !== pathOf(destination)) {
        current.searchParams.set(returnKey, pathOf(destination));
        history.replaceState(history.state, '', pathOf(current));
      }
    });
  };
  const entry = event => decorate(event.target.closest?.('a[href]'));
  for (const type of ['pointerdown', 'click', 'auxclick', 'contextmenu', 'focusin']) document.addEventListener(type, entry, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), {once:true});
  else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  window.PoptexCustomizerNavigation = {initialize};
})();
